
function getProjectPageTypeMarkers() {
    return $('.js-project-essay').attr('class');
}

export function isDistanceLearningProject() {
    const classNames = getProjectPageTypeMarkers();
    if (classNames.includes('distance-learning')) {
        return true;
    }
}

export function getDistanceLearningType() {
    const classNames = getProjectPageTypeMarkers();
    const pattern = /distance-learning[a-zA-Z-]+/i;
    const matches = classNames.match(pattern);
    return (matches.length > 0) ? matches[0] : '';
}
